export default "/processed_icon.eb28cd7f-b8d194.svg?svgr";